const _screens = {"2xl":"1400px"}
const config = { "screens": _screens,  }
export { config as default, _screens }